export const Enums = {
  resendInvitationDialogType: {
    Member: 1,
    Team: 2,
  },
  EmailMarketing: {
    ActiveCampaignSubaccountState: {
      NoAccount: 1,
      NewAccount: 2,
      ManageAccount: 3,
    },
    SubaccountStatus: {
      Active: 1,
      Disabled: 2,
      Creating: 3,
      Cancelled: 4,
    },
    AccountCancellationReasons: {
      DontNeed: 1,
      SwitchThirdParty: 2,
      Unsatisfied: 3,
      Other: 4,
    },
  },
  StripeChargeTypeCode: {
    Direct: 1,
    Destination: 2,
  },
  StripePaymentMethodType: {
    CreditCard: 1,
    GooglePay: 2,
    ApplePay: 3,
  },
  OrganizationUserBannerPreferencesTypeCode: {
    CRMIntegrationsBanner: 1,
    EmailIntegrationsBanner: 2,
  },
  quickMenuItemActions: {
    CreateWidget: 9,
    DrawWinners: 22,
    EditCampaign: 1,
    EnterActivityResults: 17,
    EnterMailInEntries: 19,
    EnterPhysicalTickets: 18,
    ManageAdministrators: 6,
    ManageCheckDonations: 4,
    ManageDonorPromoCodes: 5,
    ManageExternalDonations: 3,
    ManageItemInventory: 10,
    ManageRaffleWinners: 21,
    ManageSweepstakesWinners: 20,
    ManageUpdates: 7,
    ViewAuctionBids: 13,
    ViewAuctionWinners: 14,
    ViewContributions: 2,
    ViewCrowdfundingRewards: 29,
    ViewEarnedEntries: 26,
    ViewEventRegistration: 12,
    ViewMemberInvitations: 16,
    ViewMembers: 15,
    ViewPrizeWinners: 24,
    ViewPromoters: 25,
    ViewRaffleEntries: 27,
    ViewSoldItems: 30,
    ViewStreamManager: 8,
    ViewSweepstakesEntries: 28,
    ViewTeams: 23,
    WithdrawCampaignFunds: 11,
  },
  contributionsTab: {
    Donations: 'Donations',
    RecurringDonations: 'RecurringDonations',
    Supporters: 'Supporters',
    MemberRegistrations: 'MemberRegistrations',
    TeamRegistrations: 'TeamRegistrations',
    RegisteredDonors: 'RegisteredDonors',
    Ledger: 'Ledger',
  },
  common: {
    SmtpConnectionStatus: {
      Unverified: 1,
      Active: 2,
      Failed: 3,
    },
    CookieCode: {
      UserEmail: 1,
      ReferralCode: 3,
      ReferralUserID: 4,
      ViewedCampaigns: 6,
      ViewedMemberFullPages: 8,
      Organization: 9,
      OneAllReturnUrl: 14,
      ContributionID: 19,
    },
    CurrencyTypeCode: {
      USD: 1,
      CAD: 2,
      GBP: 3,
      EUR: 4,
      AUD: 5,
      NZD: 6,
      BRL: 7,
      DKK: 8,
      HKD: 9,
      JPY: 10,
      MXN: 11,
      NOK: 12,
      SGD: 13,
      SEK: 14,
      CHF: 15,
      INR: 16,
    },
    UserTypeCode: {
      Advocate: 1,
      Organization: 2,
      Supporter: 3,
      Csr: 4,
      Personal: 5,
    },
    CampaignOrganizerTypeCode: {
      Organization: 1,
      Advocate: 2,
      VerifiedAdvocate: 3,
      Csr: 4,
      Personal: 5,
    },
  },
  gettingStarted: {
    State: {
      Completed: 3,
      Disabled: 2,
      Enabled: 1,
    },
    ActionType: {
      OpenInviteModal: 2,
      Redirect: 1,
      OpenTemplateGallery: 3,
      OpenMyCampaignModal: 4,
    },
  },
  campaigns: {
    DrawingWinnersStatusCode: {
      Unknown: 0,
      Pending: 1,
      Started: 2,
      Completed: 3,
      Failed: 4,
    },
    DrawingTypeCode: {
      Automatic: 1,
      AutomaticOnDemand: 2,
      Manual: 3,
    },
    DrawingWinnerStatusCode: {
      Won: 1,
      Revoked: 2,
    },
    DisplayingStatusCode: {
      Draft: 1,
      Ended: 4,
      Live: 3,
      Pending: 2,
      Scheduled: 5,
    },
    PaymentProcessingTypeCode: {
      DoCharity: 4,
      External: 1,
      Internal: 2,
      PartnerFunding: 3,
      Pledge: 5,
      GivingStream: 6,
    },
    EditMode: {
      Full: 0,
      Partial: 1,
      ReadOnly: 2,
    },
    MediaTypeCode: {
      Video: 1,
      Image: 2,
    },
    StatusCode: {
      Approved: 3,
      Cancelled: 13,
      Completed: 9,
      Declined: 11,
      Draft: 1,
      Ended: 7,
      Failed: 10,
      Frozen: 6,
      Funded: 12,
      Processing: 8,
      Returned: 4,
      Started: 5,
      Off: 14,
      SubmissionProcessing: 2,
    },
    FundraisingActivityTypeCode: {
      Auction: 4,
      Coupon: 6,
      DonationPage: 11,
      Ticketing: 2,
      Funding: 1,
      Movement: 10,
      Pledge: 5,
      Project: 7,
      Raffle: 8,
      Sale: 3,
      Sweepstakes: 9,
      FreeCrowdfunding: 12,
    },
    ExtendedFundraisingActivityTypeCode: {
      Funding: 1,
      Ticketing: 2,
      Sale: 3,
      Auction: 4,
      Pledge: 5,
      Coupon: 6,
      Project: 7,
      Raffle: 8,
      Sweepstakes: 9,
      Movement: 10,
      DonationPage: 11,
      AllInOne: 13,
      PeerToPeer: 14,
      InPersonEvent: 15,
    },
    PaymentTypeCode: {
      CreditCard: 1,
      PayPal: 2,
      eCheck: 3,
      Check: 4,
      Cash: 5,
      ApplePayAndGooglePay: 8,
      RazorPay: 9,
      StripeLink: 10,
    },
    FeeChargingTypeCode: {
      ChargeSupporter: 3,
      ChargeOrganizer: 1,
      SupporterChoose: 2,
    },
    EditCampaignPricingDialogPricingTypeCode: {
      Free: 1,
      Percentage: 2,
      Unlimited: 3,
      Flex: 4,
    },
    PricingTypeCode: {
      // Free: 1,
      Percentage: 3,
      Tip: 2,
      Free: 4,
      Unlimited: 5,
      Flex: 6,
    },
    PricingPlanCode: {
      Free: 1,
      Percentage: 2,
      Unlimited: 3,
      Flex: 4,
    },
    DonorSupportTypeID: {
      None: 1,
      OrganizerButton: 2,
      ChatMessenger: 3,
    },
    PaymentProcessorTypeCode: {
      Stripe: 1,
      RazorPay: 2,
      PayPal: 3,
    },
    TeamCreationTypeCode: {
      Public: 1,
      Private: 2,
    },
    TeamMemberCreationTypeCode: {
      Public: 1,
      Private: 2,
    },
    DeliveryTypeCode: {
      Print: 1,
      Mail: 2,
      Email: 3,
      NoDelivery: 4,
      Other: 5,
    },
    PromotionBonusTypeCode: {
      Fixed: 1,
      Percentage: 2,
    },
    DonorSupportType: {
      None: 1,
      OrganizerButton: 2,
      ChatMessenger: 3,
    },
    DonorPromoCodeTypeCode: {
      Transaction: 1,
      SaleItem: 2,
      Reward: 3,
      EventTicket: 4,
      MemberRegistration: 5,
      TeamRegistration: 6,
      RafflePrize: 7,
      AuctionItem: 8,
      TicketGroup: 9,
    },
    FeatureFilter: {
      PeerToPeerFunctionality: 1,
      LiveStreaming: 2,
    },
    MyAccountPreRegistrationStatus: {
      NotStarted: 1,
      Started: 2,
      Ended: 3,
    },
    CausesAllocationType: {
      Any: 1,
      Specific: 2,
    },
    CampaignSubmissionStatus: {
      Pending: 1,
      InProgress: 2,
      Completed: 3,
      Failed: 4,
    },
  },
  user: {
    sidebarItemTypeCode: {
      MyCampaigns: 1,
      NewCampaign: 2,

      Branding: 3,
      Profile: 4,
      Funding: 5,
      Integrations: 6,
      Users: 7,

      SupporterCenter: 8,
      DonationPages: 9,

      HelpCenter: 10,
      StartGuide: 11,

      Settings: 12,

      Administration: 13,
      PartnerAdministration: 14,
      SwitchAccount: 15,

      SubscriptionButton: 999,
    },
  },
  contributions: {
    TipOptionType: {
      Predefined: 1,
      Other: 2,
    },
    BidStatusCode: {
      Draft: 1,
      Winning: 2,
      Losing: 3,
      PaymentEmailSent: 4,
      Failed: 5,
      Won: 6,
      Cancelled: 7,
      Revoked: 8,
      Lost: 9,
      Voided: 10,
      PaymentAuthenticationRequired: 11,
    },
    FlatPledgeParticipantType: {
      MemberOrTeam: 1,
      Organization: 2,
    },
    ParticipantType: {
      Member: 1,
      Organization: 3,
      Team: 2,
    },
    EditContributionAmountType: {
      Flat: 2,
      PerUnit: 3,
      Percentage: 1,
    },
    PaymentDisplayingStatusCode: {
      AuthenticationRequired: 8,
      Cancelled: 6,
      Failed: 4,
      Free: 7,
      Paid: 3,
      Pending: 1,
      Submitted: 2,
      Voided: 5,
    },
    BidDisplayingStatus: {
      Draft: 1,
      Winning: 2,
      Outbid: 3,
      Cancelled: 4,
      Failed: 5,
      Won: 6,
      Revoked: 7,
    },
    PaymentStatusCode: {
      Pending: 1,
      Submitted: 2,
      Paid: 3,
      Declined: 4,
      Voided: 5,
      Cancelled: 6,
      Free: 7,
      AuthenticationRequired: 8,
      Recovery: 9,
      Failed: 10,
    },
    RecurrenceTypeCode: {
      TotalOccurences: 1,
      EndDate: 2,
      Ongoing: 3,
    },
    RecurrencePeriodType: { Week: 1, Month: 2, Quarter: 3, Year: 4 },
    RecurrenceStatus: { Draft: 1, Active: 2, Ended: 3, Cancelled: 4 },
    AuctionPaymentDisplayingStatus: {
      AuthenticationRequired: 8,
      Cancelled: 6,
      Failed: 4,
      Free: 7,
      Paid: 3,
      Pending: 1,
      Revoked: 9,
      Submitted: 2,
      Voided: 5,
    },
    ContributionPrivacyCode: {
      Public: 1,
      Anonymous: 2,
      InNameOf: 3,
    },
    StatusCode: {
      Draft: 1,
      Submitted: 2,
      Cancelled: 3,
    },
    ContributionCompletionResultCode: {
      NotNeeded: 1,
      Succeed: 2,
      FailedDueToPassedEventDate: 3,
      FailedAndRefundedDueToPassedEventDate: 4,
      FailedDueToNotEnoughItemsLeft: 5,
      FailedAndRefundedDueToNotEnoughItemsLeft: 6,
      FailedDueToNotFound: 7,
      FailedDueToOutbid: 8,
      FailedDueToUserAlreadyHasBidDonation: 9,
      FailedDueToCaptureFailure: 10,
      FailedDueToForbiddenCardFundingType: 11,
    },
  },
  organizations: {
    ProofOfAffiliationTypeCode: {
      Email: 1,
      Website: 2,
      Other: 3,
    },
    SupporterType: {
      All: 1,
      Donor: 2,
      P2PParticipant: 3,
      Promoter: 4,
      PreRegistrant: 5,
    },
    SubDomainType: {
      AdvancedSetup: 3,
      No: 1,
      SimpleSetup: 2,
    },
    OrganizationSubscriptionTypeCode: {
      Basic: 1,
      Trial: 2,
      Plus: 3,
      Grandfather: 4,
    },
    OrganizationOwnTypeCode: {
      Affiliated: 2,
      NotRelated: 3,
      Owned: 1,
    },
    StripeConnectedAccountType: {
      Primary: 1,
      Secondary: 2,
    },
    StripeAccountStatus: {
      Activated: 3,
      Blocked: 2,
      Pending: 1,
    },
    PaypalAccountStatus: {
      Pending: 1,
      Blocked: 2,
      Activated: 3,
    },
    PledgeAccountStatus: {
      Pending: 1,
      Blocked: 2,
      Activated: 3,
    },
    StatusCode: {
      Draft: 1,
      PendingVerification: 2,
      Frozen: 3,
      VerificationSubmitted: 4,
      Approved: 5,
      Declined: 6,
      PendingApproval: 7,
    },
    StaffRoleCode: {
      Administrator: 1,
      Staff: 2,
      Advocate: 3,
    },
    StaffInvitationStatusCode: {
      Invited: 1,
      Accepted: 2,
    },
    DirectFundsTypeCode: {
      Stripe: 1,
      PayPal: 2,
    },
    OrganizationDonorProfileEventType: {
      Transaction: 1,
      P2PRegistration: 2,
      PromoterSignedUp: 3,
      RecurringDonation: 4,
      SystemEmailSent: 5,
      PreRegistration: 6,
    },
    SendGridMessageStatusCode: {
      Processing: 1,
      Processed: 2,
      Delivered: 3,
      Open: 4,
      Dropped: 5,
      Deferred: 6,
      Bounce: 7,
      Failed: 8,
    },
    ReportItemTypeCode: {
      AuctionItem: 1, // "Auction"
      SaleItem: 2, // "Sale"
      RafflePrize: 3, // "Raffle"
      SweepstakesPrize: 4, // "Sweepstakes"
      Reward: 5, // "Crowdfunding"
      EventRegistration: 6, // "Event Ticket"
      EventGroupRegistration: 7, // "Event Tickets Group"
    },
  },
  Import: {
    EntityImportTypeCode: {
      Member: 1,
      Team: 2,
      PhysicalRaffleTicket: 3,
      Organization: 4,
      ActivityResult: 5,
      FinalizingActivity: 6,
      PartnerSplitException: 7,
      PartnerOrganization: 8,
    },
    EntityImportStatusCode: {
      Initialized: -2,
      Preparing: -1,
      Pending: 0,
      Started: 1,
      Completed: 2,
      Failed: 3,
    },
  },
  partners: {
    PricingOptionsOwnerTypeCode: {
      Partner: 1,
      CampaignOrganizer: 2,
    },
    PaymentProcessorTypeCode: {
      RazorPay: 2,
      Stripe: 1,
    },
    VerificationProcessTypeCode: {
      RallyUpVerificationOrganization: 1,
      SimpleVerificationOrganization: 2,
    },
    SimpleVerificationMethodTypeCode: {
      ManualApproval: 1,
      AutoApproval: 2,
    },
    StripeChargeTypeCode: {
      Direct: 1,
      Destination: 2,
    },
  },
  organizationVerification: {
    VerificationType: {
      EmailVerification: 1,
      IdVerification: 2,
    },
    VerificationStepCode: {
      Ein: 0,
      OrganizationInfo: 1,
      FundingInfo: 2,
      Pricing: 3,
    },
    StripeIdVerificationStatus: {
      Requested: 1,
      RequiresInput: 2,
      Processing: 3,
      Verified: 4,
      Canceled: 5,
    },
    EmailVerificationResultCode: {
      Invalid: 1,
      Expired: 2,
      Verified: 3,
    },
  },
  startPage: {
    StepCode: {
      UserInfo: 1,
      Organization: 2,
    },
    CustomerTypeCode: {
      Org501: 1,
      GroupOfOrganization: 2,
      CompanyOrBusiness: 3,
      CharitableOrganization: 4,
      Other: 5,
      Individual: 6,
    },
    CustomerTypeCodeNew: {
      Registered501Nonprofit: 1,
      OtherNonProfitGroupOrOrganization: 2,
      PersonalCause: 3,
    },
    FundraisingTypeCode: {
      NonprofitOrganization: 1,
      MyCompanyOrBusiness: 2,
      CharityOrNonprofit: 3,
      APersonalCause: 4,
    },
    FundraisingTypeCodeNew: {
      EmployeeContractor: 1,
      CharityCoordinator: 2,
      Other: 3,
    },
    OrganizationSizeTypeCode: {
      From0To2: 1,
      From3To9: 2,
      From10To49: 3,
      From50To499: 4,
      From500To9999: 5,
      From10000AndMore: 6,
    },
    OrganizationAnnualRaiseLevelTypeCode: {
      From0To50K: 1,
      From50KTo200K: 2,
      From200KTo500K: 3,
      From500KTo1M: 4,
      Over1M: 5,
      DontKnow: 6,
    },
    CurrencyPosition: {
      Left: 1,
      Right: 2,
    },
  },
  Export: {
    OrganizerDonationsExportType: {
      Common: 1,
      ByFundraisingActivityType: 2,
    },
  },
  OrganizerSendEmailReturnTypeCode: {
    Contributions: 1,
    Members: 2,
    Bids: 4,
    AuctionWinners: 5,
    Teams: 7,
    Tickets: 8,
  },
  DonorEventBalanceStatusTypeCode: {
    Open: 1,
    ChargeFailed: 2,
    Closed: 3,
    // Not showing deleted status at all
    // Deleted: 4,
  },
  Administration: {
    Campaigns: {
      Management: {
        FeatureFilter: {
          InPersonEvent: 1,
        },
      },
    },
    OrganizationUserStatusCode: {
      Invited: 1,
      Joined: 2,
    },
  },
} as const;
